export { LOYALTY_MARKETS, isLoyaltyMarket } from "@viking/yotpo";
export type { LoyaltyMarket } from "@viking/yotpo";

import { env } from "@/env.mjs";

const GUID_MAP: Record<string, string | undefined> = {
	NO: env.NEXT_PUBLIC_YOTPO_GUID_NO,
	SE: env.NEXT_PUBLIC_YOTPO_GUID_SE,
	DK: env.NEXT_PUBLIC_YOTPO_GUID_DK,
	FI: env.NEXT_PUBLIC_YOTPO_GUID_FI,
	EE: env.NEXT_PUBLIC_YOTPO_GUID_FI,
	DE: env.NEXT_PUBLIC_YOTPO_GUID_DE,
	AT: env.NEXT_PUBLIC_YOTPO_GUID_DE,
};

export const getYotpoGuid = (country: string): string => {
	const guid = GUID_MAP[country] ?? env.NEXT_PUBLIC_YOTPO_GUID;
	if (!guid) throw new Error(`No Yotpo GUID configured for country: ${country}`);
	return guid;
};
